import { useNavigate } from "react-router-dom";

// Named route registry — maps intent aliases to actual paths
const ROUTE_MAP = {
    // Home
    home: "/",
    landing: "/",

    // About
    about: "/about",
    "about-us": "/about",

    // Services
    services: "/services",
    "all-services": "/services",
    "service-category": "/services/:id",
    "service-detail": "/services/:id",

    // Packages
    packages: "/packages",
    "all-packages": "/packages",

    // Blog
    blog: "/blog",
    blogs: "/blog",
    articles: "/blog",

    // Contact
    contact: "/contact",
    "contact-us": "/contact",
    support: "/contact",

    // Catalog
    catalog: "/catalog",
    products: "/catalog",

    // Protected user routes
    bookings: "/my-bookings",
    "my-bookings": "/my-bookings",
    appointments: "/my-bookings",
    "booking-detail": "/my-bookings/:type/:bookingId",

    profile: "/user-profile",
    "my-profile": "/user-profile",
    account: "/user-profile",

    cart: "/service-cart",
    "my-cart": "/service-cart",
    "service-cart": "/service-cart",

    // Auth
    login: "/login",
    register: "/register",
    signup: "/register",
};

const resolveRoute = (pathOrAlias, params = {}) => {
    // Check if it's a named alias first, else treat as raw path
    let template = ROUTE_MAP[pathOrAlias] ?? pathOrAlias;

    // Replace :param placeholders
    Object.keys(params).forEach((key) => {
        template = template.replace(`:${key}`, encodeURIComponent(params[key]));
    });

    return template;
};

export const useSmartNavigate = () => {
    const navigate = useNavigate();

    /**
     * goTo(alias, params, options)
     *
     * Examples:
     *   goTo("home")
     *   goTo("services")
     *   goTo("service-detail", { id: "abc123" })
     *   goTo("booking-detail", { type: "service", bookingId: "xyz" })
     *   goTo("/custom-path")                         // raw path still works
     */
    const goTo = (alias, params = {}, options = {}) => {
        const finalPath = resolveRoute(alias, params);
        navigate(finalPath, options);
    };

    /**
     * goToService(categoryId)
     * Shorthand for navigating to a specific service category
     */
    const goToService = (categoryId) => {
        navigate(`/services/${encodeURIComponent(categoryId)}`);
    };

    /**
     * goToBooking(type, bookingId)
     * Shorthand for navigating to a specific booking detail
     */
    const goToBooking = (type, bookingId) => {
        navigate(`/my-bookings/${encodeURIComponent(type)}/${encodeURIComponent(bookingId)}`);
    };

    return { goTo, goToService, goToBooking, ROUTE_MAP };
};